var map = {
	"./en/adminCompanies.json": 46708,
	"./es/adminCompanies.json": 69362,
	"./fr/adminCompanies.json": 81500,
	"./it/adminCompanies.json": 89821,
	"./pt-BR/adminCompanies.json": 78362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42163;